import Livejoy from "./Livejoy";
import Suki from "./Suki";

const aplicativosData = {
  Livejoy,
  Suki,
};

export default aplicativosData;
